<!--婴幼儿管理-->
<template>
    <div>
      <el-form
        ref="registerRef"
        :model="createParam"
        :rules="rules"
        label-width="120px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号:" prop="userPhone">
              <el-input
                v-model="createParam.userPhone"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体验卡类型:" prop="userPhone">
              <el-select
                v-model="CardType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in [
                    { label: 'A', value: 'A' },
                    { label: 'B', value: 'B' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="家长姓名:">
              <el-input
                v-model="createParam.userName"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体验卡:">
              <el-select
                v-model="createParam.expCardId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in storeLessonExpCards"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="会员姓名:" prop="name">
              <el-input
                v-model="createParam.name"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体验卡价格:">
              <el-input-number
                v-model="createParam.expCardPay"
                placeholder=""
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="小名:">
              <el-input
                v-model="createParam.petName"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="次数:">
              <el-input-number
                v-model="createParam.expCardNum"
                placeholder=""
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="性别:" prop="gender">
              <el-select
                v-model="createParam.gender"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in genderOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课时:">
              <el-input-number
                placeholder=""
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生日:" prop="birthday">
              <el-date-picker
                v-model="createParam.birthday"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="等级:" prop="userPhone">
              <el-select placeholder="请选择">
                <el-option
                  v-for="item in [
                    { label: '一级', value: 1 },
                    { label: '二级', value: 2 },
                    { label: '三级', value: 3 },
                    { label: '四级', value: 4 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="小区:">
              <el-input
                v-model="createParam.detailAddress"
                placeholder="请输入小区"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人:">
              <el-select
                v-model="createParam.workerInfoId"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allWorker"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="渠道:">
              <el-select
                v-model="createParam.source"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="createParam.source === '网络咨询(NI)'">
            <el-form-item label="二级渠道:">
              <el-select
                v-model="createParam.sourceTwo"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in sourceTwoOptions"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="createParam.source === '异业合作'">
            <el-form-item label="合作方:">
              <el-select
                v-model="createParam.sourceTwo"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in frontBizTypeList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="createParam.source === 'Peferral转介绍'">
            <el-form-item label="介绍人手机号:">
              <el-input
                v-model="createParam.introducer"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注:">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入内容"
            style="width: 740px"
          ></el-input>
        </el-form-item>
        <el-form-item label="语音备注:">
          <div style="width: 740px">
            <soundRecording />
          </div>
        </el-form-item>
      </el-form>
    </div>
  </template>
  
  <style></style>
  
  <script>
  import soundRecording from "@/components/soundRecording";
  export default {
    name: "UserChildDetail",
    props: {
      storeLessonExpCards: Array,
    },
    components: {
      soundRecording,
    },
    data() {
      return {
        // storeFrontId: globaldata.getAdminStore().storeFrontId,
        rules: {
          userName: [
            { required: true, message: "请输入家长姓名", trigger: "blur" },
          ],
          userPhone: [
            { required: true, message: "请输入家长手机号", trigger: "blur" },
          ],
          name: [{ required: true, message: "请输入会员姓名", trigger: "blur" }],
          gender: [
            { required: true, message: "请选择孩子性别", trigger: "blur" },
          ],
          birthday: [
            { required: true, message: "请选择孩子生日", trigger: "blur" },
          ],
          detailAddress: [
            { required: true, message: "请输入社区", trigger: "blur" },
          ],
        },
        genderOptions: [
          {
            value: "0",
            label: "男",
          },
          {
            value: "1",
            label: "女",
          },
        ],
        createParam: {},
        allWorker: [],
        sourceOptions: [
          { name: "自然到访(WI)" },
          { name: "电话咨询(CI)" },
          { name: "网络咨询(NI)" },
          { name: "Peferral转介绍" },
          { name: "PT带到访" },
          { name: "CO" },
          { name: "异业合作" },
        ],
        sourceTwoOptions: [
          { name: "美团" },
          { name: "大众点评" },
          { name: "官网" },
          { name: "其他" },
        ],
        frontBizTypeList: [],
        CardType: "A",
      };
    },
    mounted() {
      this.initParam();
    //   globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    //   let param = {
    //     storeFrontId: globaldata.getAdminStore().storeFrontId,
    //   };
    //   frontBizTypeList(param).then((response) => {
    //     this.frontBizTypeList = response.data;
    //   });
    },
    created() {},
    methods: {
      // 初始化参数
      initParam() {
        this.createParam = {
          gender: "",
          userPhone: "",
          userName: "",
          phoneCode: "",
          name: "",
          petName: "",
          birthday: "",
          detailAddress: "",
          expCardId: null,
          expCardPay: 0,
        };
      },
      getStoreWorkersInfo(workers) {
        this.allWorker = workers;
      },
      handleCancel() {
        this.$emit("onBtnCancel");
      },
      handleCreate(registerRef) {
        this.$refs[registerRef].validate((valid) => {
          if (valid) {
            // let param = this.createParam;
            // param.storeFrontId = globaldata.getAdminStore().storeFrontId;
            // param.createAdminId = globaldata.getAdminStore().id;
            // createUserChild(param).then((response) => {
            //   messageUtils.successMsg(this, "创建成功");
            //   this.$emit("onBtnCreate");
            // });
          } else {
            return false;
          }
        });
      },
      handleCommand(command) {},
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/views/marketing-manager/potential-customers/components/data-import-follow.vue